import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const SearchInputWrapper = styled(Box)`
  display: flex;
  align-items: center;
  position: relative;

  .search-icon {
    position: absolute;
    left: ${theme.spacing.small}px;
    z-index: 1;
  }

  .clear-btn {
    position: absolute;
    right: ${theme.spacing.xSmall}px;
  }

  .search-bar {
    width: 100%;
    height: 48px;
  }

  .MuiOutlinedInput-input {
    box-sizing: border-box;
    border: 1px solid ${theme.colors.controlBorder};
    border-radius: ${theme.attributes.borderRadius.tertiary};
    background: transparent;
    height: 48px;
    padding: 0 50px 0 44px;
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 24px;
    letter-spacing: 0.5px;

    &::placeholder {
      color: ${theme.colors.devicesSecondaryText};
      opacity: 1;
    }

    &:focus {
      border-color: ${theme.colors.cta};
    }
  }

  .MuiOutlinedInput-root {
    padding: 0;
  }

  fieldset {
    border: none;
  }

  /* A CSS fill property beats the icon's baked fill attribute and resolves the var. */
  html[data-theme='light'] & {
    .MuiOutlinedInput-input {
      border-color: ${theme.colors.dropdownBorder};

      &:focus {
        border-color: ${theme.colors.cta};
      }
    }

    .search-icon svg path {
      fill: ${theme.colors.devicesSecondaryText};
    }
  }
`
